module.exports = __webpack_public_path__ + "img/graphics.f95fed34.png";